<template>
  <div :class="$style.container">
    <Title :class="$style.title" :title-params="slice.primary.title" />
    <RichText :class="$style.subtitle" :text-params="slice.primary.subtitle" />
    <div :class="$style.cards">
      <div v-for="(card, index) in slice.items" :key="`card-${index}`" :class="$style.card">
        <PImage :class="$style.cardIcon" :image-object="card.tool_illu" />
        <Title :class="$style.cardTitle" :title-params="card.tool_title" />
        <RichText :class="$style.cardDescription" :text-params="card.tool_subtitle" />
      </div>
    </div>
  </div>
</template>

<script>
import RichText from '~/components/RichText'
import Title from '~/components/Title'
import PImage from '~/components/PImage'

export default {
  name: 'PartnersTools',
  components: {
    RichText,
    Title,
    PImage,
  },
  props: {
    slice: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style lang="scss" module>
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 1280px;
  margin: 80px 24px;

  text-align: center;

  @include above(medium) {
    margin: 128px auto 128px;
  }
}
.title {
  font-weight: 200;
  font-size: 40px;
  line-height: 48px;
  @include below(small) {
    font-size: 32px;
  }
}
.subtitle {
  max-width: 840px;
  margin-bottom: 40px;

  @include typo-body;
  @include above(medium) {
    margin-bottom: 64px;
  }
}

.cards {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  justify-content: center;

  @include above(medium) {
    gap: 40px;
  }
}

.card {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 400px;
  min-height: 255px;
  padding: 24px 32px;
  border: 1px solid $gray-100;
  border-radius: 8px;

  text-align: center;
}

.cardIcon {
  width: 48px;
}

.cardTitle {
  @include typo-headline-bold;

  margin-top: 24px;
}

.cardDescription {
  @include typo-body;

  color: $gray-700;
}
</style>
